module.exports = __webpack_public_path__ + "img/P150T_weapon_97.71755cee.png";